import React from 'react';
import { ContentPage } from 'modules2/content-page';
import { SortMenu } from 'modules2/components';
import { GenreStationCard } from './components';
import container from "./GenreStation.container";
import genresList from 'modules2/data-json/genres.json';

const Station = (props) => {
    const {
        radioState,
        onSetGenres,
        onFetchGenresRadioListStart,
    } = props;
    const title = radioState.currentGenres + ' Radio Lists';
    const currentCountryCode = radioState.currentCountryCode;

    const handleStateChange = (genresId) => {
        // console.log('genres selected:: ', genresId);
        onSetGenres(genresId);
        onFetchGenresRadioListStart(radioState.currentCountryCode, genresId);
    };

    let list = [];
    genresList.map((genre) => {
        if (genre.code === currentCountryCode || genre.code === '*') {
            list.push(genre);
        }
    });

    return(
        <ContentPage
            header={{
                title: title,
                description: '',
                controls: (
                    <SortMenu
                        title="Select Genres"
                        items={list}
                        initialItem={radioState.currentGenres}
                        onSortByChange={handleStateChange}
                    />
                )
            }}
            body={<GenreStationCard />}
        />
    );
};

export default container(Station);